import Program from 'wwg-utilities/dist/collections/program';
import apiClient from './axiosClient';

const getRelatedProgramsRequest = async (
  id: string,
  page: number,
  region?: string,
): Promise<Program[]> => {
  return apiClient
    .get(`programs/related-programs/${id}`, { params: { page, region } })
    .then((res) => res.data);
};

export default getRelatedProgramsRequest;
